import { Modal } from './Modal';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// Shared "are you sure" dialog — sassy copy is passed in per call site, but the
// chrome now comes from the common Modal (centered variant) so it matches every
// other overlay in the app.
export function ConfirmModal({ open, title, message, confirmLabel = "Yeah, I'm out", cancelLabel = "Wait, no", onConfirm, onCancel }: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onCancel} variant="center" maxWidth={400}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#fff', marginBottom: '0.75rem' }}>{title}</h2>
        <p style={{ color: '#aaa', fontSize: '0.95rem', marginBottom: '1.75rem', lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button onClick={onCancel} className="btn btn-secondary" style={{ flex: 1, padding: '0.85rem' }}>
            {cancelLabel}
          </button>
          <button onClick={onConfirm} className="btn btn-danger" style={{ flex: 1, padding: '0.85rem' }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
